import { Avatar } from '@mui/material';
import React from 'react';
import { formatDateTime } from '@utils';

const NotificationList = ({
  mensageria,
  selectedNotification,
  handleOpenMensageria,
}) => (
  <div className="mensageria-list">
    {mensageria?.map((notification) => (
      <div
        key={notification.idMsg}
        role="button"
        tabIndex={0}
        className={`mensageria-list-item ${
          selectedNotification?.idMsg === notification.idMsg ? 'selected' : ''
        }`}
        onClick={() => handleOpenMensageria(notification.idMsg)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            handleOpenMensageria(notification.idMsg);
          }
        }}
      >
        <span
          className="mensageria-dot"
          style={{
            visibility: notification.Lida === null ? 'visible' : 'hidden',
          }}
        />
        <Avatar
          sx={{
            width: 40,
            height: 40,
            bgcolor: '#E77708',
            fontSize: '1rem',
          }}
        />
        <div className="mensageria-item-content">
          <p className="mensageria-item-title">{notification.Titulo}</p>
          <span className="mensageria-item-time">
            {(() => {
              if (notification.Lida !== null) {
                return `Lida em ${formatDateTime(notification.Lida)}`;
              }
              if (notification.Recebida) {
                return `Recebida em ${formatDateTime(notification.Recebida)}`;
              }
              return '';
            })()}
          </span>
        </div>
      </div>
    ))}

    {mensageria?.length === 0 && (
      <div className="mensageria-empty">
        <p>Nenhuma notificação encontrada.</p>
      </div>
    )}
  </div>
);

export default NotificationList;
